import { Box, CommandItem, Icon, Text } from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

import type { QuickFilterOption } from "./quick-filter-options";
import { QuickOptionFace } from "./quick-option-face";

type QuickOptionRowProps = Omittable<{
  /** Unique within the list Base UI registers the row against. */
  value: string;
  option: QuickFilterOption;
  selected: boolean;
  onToggle: () => void;
  /** Show the option's group inline. For a list whose group slot is already
   *  spent — the cross-section search heads its groups with the FILTER's name,
   *  so a stage's workflow has nowhere else to go. */
  showGroup?: boolean;
}>;

/**
 * ONE selectable filter value, wherever a list OFFERS it — a section's own
 * popover and the panel's cross-section search.
 *
 * Pressing toggles without closing the list, so several values go on in one
 * pass, and the trailing check is the applied state: a row read twice tells
 * the same story either way.
 */
export function QuickOptionRow({
  value,
  option,
  selected,
  onToggle,
  showGroup = false,
}: QuickOptionRowProps) {
  return (
    <CommandItem value={value} onClick={onToggle}>
      <Box
        direction="row"
        align="center"
        justify="between"
        gap="sm"
        fill="width"
        minHeight={24}
      >
        <Box direction="row" align="center" gap="sm" shrink minWidth={0}>
          <QuickOptionFace option={option} />
          {showGroup && option.group ? (
            <Text size="xs" variant="faint" truncate>
              {option.group}
            </Text>
          ) : null}
        </Box>
        <Box direction="row" align="center" gap="sm" shrink={false}>
          {option.count ? (
            <Text size="xs" tabular variant="muted">
              {option.count}
            </Text>
          ) : null}
          {selected ? <Icon name="check" size="sm" color="brand" /> : null}
        </Box>
      </Box>
    </CommandItem>
  );
}
